import { Link } from 'react-router-dom'
import { ArrowLeft } from 'lucide-react'

const Privacy = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto bg-white rounded-2xl shadow-lg p-8 md:p-12">
        <Link
          to="/"
          className="inline-flex items-center text-primary-600 hover:text-primary-700 mb-6"
        >
          <ArrowLeft className="w-4 h-4 mr-2" />
          На главную
        </Link>

        <h1 className="text-3xl font-bold text-gray-900 mb-6">
          Политика конфиденциальности WB Greenlight
        </h1>

        <div className="prose prose-gray max-w-none space-y-4 text-gray-700">
          <p className="text-sm text-gray-500">
            Дата вступления в силу: 6 июля 2026 г.
          </p>

          <h2 className="text-xl font-semibold text-gray-900 mt-6">1. Общие положения</h2>
          <p>
            Настоящая Политика конфиденциальности (далее — Политика) определяет порядок обработки
            и защиты персональных данных пользователей сервиса WB Greenlight
            (далее — Сервис), предоставляемого самозанятым Курбановым Камраном Айтакиновичем
            (ИНН 180805638897).
          </p>

          <h2 className="text-xl font-semibold text-gray-900 mt-6">2. Какие данные мы собираем</h2>
          <p>При использовании Сервиса мы собираем следующие данные:</p>
          <ul className="list-disc list-inside space-y-1 ml-4">
            <li>Email-адрес (для регистрации и связи)</li>
            <li>Хешированный пароль (для авторизации)</li>
            <li>API-ключ Wildberries (для интеграции с личным кабинетом селлера)</li>
            <li>Описания карточек товаров, отправляемые на проверку</li>
            <li>Технические данные: IP-адрес, User-Agent, время посещения</li>
          </ul>

          <h2 className="text-xl font-semibold text-gray-900 mt-6">3. Цели обработки данных</h2>
          <p>Мы обрабатываем данные для:</p>
          <ul className="list-disc list-inside space-y-1 ml-4">
            <li>Предоставления доступа к функционалу Сервиса</li>
            <li>Проверки карточек товаров на соответствие оферте Wildberries</li>
            <li>Отправки уведомлений о статусе подписки и важных событиях</li>
            <li>Улучшения качества Сервиса</li>
          </ul>

          <h2 className="text-xl font-semibold text-gray-900 mt-6">4. Хранение и защита данных</h2>
          <p>
            Мы применяем технические и организационные меры для защиты ваших данных:
          </p>
          <ul className="list-disc list-inside space-y-1 ml-4">
            <li>Пароли хранятся в хешированном виде (bcrypt)</li>
            <li>API-ключи шифруются при хранении</li>
            <li>Передача данных осуществляется по защищённому протоколу HTTPS</li>
            <li>Регулярное резервное копирование базы данных</li>
          </ul>

          <h2 className="text-xl font-semibold text-gray-900 mt-6">5. Передача данных третьим лицам</h2>
          <p>
            Мы не передаём ваши персональные данные третьим лицам, за исключением:
          </p>
          <ul className="list-disc list-inside space-y-1 ml-4">
            <li>Платёжных систем (YooKassa) — только для обработки оплат</li>
            <li>Wildberries API — только API-ключ для работы с вашим личным кабинетом</li>
            <li>По требованию законодательства РФ</li>
          </ul>

          <h2 className="text-xl font-semibold text-gray-900 mt-6">6. Права пользователя</h2>
          <p>Вы имеете право:</p>
          <ul className="list-disc list-inside space-y-1 ml-4">
            <li>Получить информацию о хранящихся данных</li>
            <li>Требовать исправления или удаления данных</li>
            <li>Отозвать согласие на обработку данных (путём удаления аккаунта)</li>
            <li>Подать жалобу в Роскомнадзор</li>
          </ul>

          <h2 className="text-xl font-semibold text-gray-900 mt-6">7. Сроки хранения</h2>
          <p>
            Данные хранятся в течение всего срока использования Сервиса.
            После удаления аккаунта данные удаляются в течение 30 дней,
            за исключением данных, которые мы обязаны хранить по закону.
          </p>

          <h2 className="text-xl font-semibold text-gray-900 mt-6">8. Контактная информация</h2>
          <p>
            По вопросам обработки персональных данных обращайтесь:<br />
            Email:{' '}
            <a href="mailto:kamran@kurbanov.me" className="text-primary-600 hover:underline">
              kamran@kurbanov.me
            </a>
            <br />
            Сайт:{' '}
            <a href="https://wb-greenlight.ru" className="text-primary-600 hover:underline">
              wb-greenlight.ru
            </a>
          </p>
        </div>

        <div className="mt-8 pt-6 border-t border-gray-200 text-sm text-gray-500">
          <p>© 2026 WB Greenlight. ИНН 18080563897</p>
        </div>
      </div>
    </div>
  )
}

export default Privacy